import * as Sentry from "@sentry/browser";

export const logError = error => {
  console.log(error);
  Sentry.captureException(error);
};
